import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '@sharedModule/directives/control-value-accessor.directive';
import { InputData } from '@sharedModule/models/input-data.model';

@Component({
  selector: 'app-input-datepicker',
  templateUrl: './input-datepicker.component.html',
  styleUrl: './input-datepicker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDatepickerComponent),
      multi: true,
    },
  ],
})
export class InputDatepickerComponent<
  T,
> extends ControlValueAccessorDirective<T> {
  @Input() inputData?: InputData;
}
